'use strict';

// This order should not be changed under any circumstances
var BREAKPOINTS = {
  xs: '320px',
  sm: '568px',
  md: '768px',
  lg: '1024px',
  xl: '1304px'
};

module.exports = BREAKPOINTS;
